import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/css';

export function initAccreditationsCarousels() {
    document.querySelectorAll('[data-accreditations-carousel]').forEach((sectionEl) => {
        const el = sectionEl.querySelector('.accreditations__swiper');
        if (!el) return;

        new Swiper(el, {
            modules: [Navigation],
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 20,
            speed: 400,
            loop: true,
            breakpoints: {
                1024: {
                    slidesPerView: 2,
                },
            },
            navigation: {
                prevEl: sectionEl.querySelector('.accreditations__nav-prev'),
                nextEl: sectionEl.querySelector('.accreditations__nav-next'),
            },
        });
    });
}
